export default __webpack_public_path__ + "static/media/exclutionIcon.94ea5c89.svg";